module.exports = {
  common: {
    title: 'NeonCRM',
    copyright: 'NeonCRM Copyright © 2018 Z2 Systems, Inc. All rights reserved.',
    language: 'Language'
  }
}



// WEBPACK FOOTER //
// ./src/lang/en-US.js